export default __webpack_public_path__ + "static/O0300-b7dd4fc4fdc41670509dda816c5344f0.png";